import { render } from "./AppTopbar.vue?vue&type=template&id=8dd5a9dc&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=8dd5a9dc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd5a9dc"]])

export default __exports__